import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledEnrichmentErrorWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 24px 16px 16px 16px;
    height: 304px;
    width: 328px;
`;

export const StyledEnrichmentErrorIcon = styled.div`
    display: flex;
    justify-content: center;
    svg {
        width: 188px;
        height: 188px;
    }
`;

export const StyledEnrichmentErrorTitle = styled.div`
    display: flex;
    margin-top: 16px;
    justify-content: center;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])}
`;

export const StyledEnrichmentErrorDescription = styled.div`
    display: flex;
    justify-content: center;
    ${setFontVariant("caption", colorsPalettes.carbon[300])}
`;

export const StyledEnrichmentButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
`;
